
import Vue from 'vue'
import { debounce, DebouncedFunc, noop } from 'lodash'

interface IData {
  section: 'pem' | 'protobuf' | 'key-file' | 'base-64'
  password: string
  pem: string
  generatePEM: DebouncedFunc<any>
}

export default Vue.extend({
  data: (): IData => ({
    section: 'pem',
    password: '',
    pem: '',
    generatePEM: debounce(noop)
  }),

  computed: {
    categories() {
      return ['PEM', 'Protobuf', 'Key File', 'Base64']
    },

    protobuf(): string {
      return this.$ipfs.privateKey?.toProtobuf() || ''
    },

    base64(): string {
      return Buffer.from(this.$ipfs.privateKey?.marshal || '').toString('base64')
    }
  },

  watch: {
    password() {
      this.generatePEM()
    }
  },

  created() {
    this.generatePEM = debounce(this._generatePEM, 400)
    this.generatePEM()
  },

  methods: {
    _generatePEM() {
      this.pem = this.$ipfs.privateKey?.toPem({ type: 'protobuf', password: this.password }) || ''
    },

    download() {
      this.$ipfs.privateKey?.download()
    }
  }
})
